<template>
  <div v-if="!isContinue" class="new-model-form-container">
    <b-row class="mb-2">
      <b-col class="header-new-model" cols="12">Tạo mới phiếu yêu cầu</b-col>
    </b-row>
    <b-row>
      <b-col cols="3" offset="3">
        <b-form-group>
          <label class="col-form-label"
          >Mức độ khẩn cấp<span class="text-danger"> *</span></label
          >
          <Select2
              v-model="isUrgent"
              :class="isBlur && !isUrgent ? `select2-error` : ''"
              :options="urgentSelectData"
              placeholder="Mức độ khẩn cấp"
          />
          <label
              v-if="isBlur && !isUrgent"
              class="col-form-label text-danger"
              style="padding-bottom: 0"
          >Vui lòng chọn mức độ khẩn cấp</label
          >
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3" offset="3">
        <b-form-group>
          <label class="col-form-label">Loại<span class="text-danger"> *</span></label>
          <Select2
              v-model="type"
              :class="isBlur && !type ? `select2-error` : ''"
              :options="requestTypeSelectData"
              placeholder="Loại"
          />
          <label
              v-if="isBlur && !type"
              class="col-form-label text-danger"
              style="padding-bottom: 0"
          >Vui lòng chọn loại</label
          >
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group>
          <label class="col-form-label"
          >Sản phẩm<span class="text-danger"> *</span></label
          >
          <Select2
              v-model="campType"
              :class="isBlur && !campType ? `select2-error` : ''"
              :options="dropListSelectData"
              placeholder="Sản phẩm"
          />
          <label
              v-if="isBlur && !campType"
              class="col-form-label text-danger"
              style="padding-bottom: 0"
          >Vui lòng chọn sản phẩm</label
          >
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3" offset="3">
        <b-form-group>
          <label class="col-form-label"
          >Thời gian bắt đầu<span class="text-danger"> *</span></label
          >
          <b-form-datepicker
              v-model="startDate"
              :class="isBlur && isValidDate ? 'error' : ''"
              :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
              locale="vi-VN"
              placeholder="dd/mm/yyyy"
          />
          <label
              v-if="isBlur && isValidDate"
              class="col-form-label text-danger"
              style="padding-bottom: 0"
          >Thời gian bắt đầu không vượt quá thời gian kết thúc</label
          >
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group>
          <label class="col-form-label"
          >Thời gian kết thúc<span class="text-danger"> *</span></label
          >
          <b-form-datepicker
              v-model="endDate"
              :class="isBlur && isValidDate ? 'error' : ''"
              :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
              locale="vi-VN"
              placeholder="dd/mm/yyyy"
          />
          <label
              v-if="isBlur && isValidDate"
              class="col-form-label text-danger"
              style="padding-bottom: 0"
          >Thời gian kết thúc không nhỏ hơn thời gian bắt đầu</label
          >
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-align-right" cols="12">
        <b-button class="btn-icon" variant="danger" @click="onContinue">
          Tiếp tục
        </b-button>
      </b-col>
    </b-row>
  </div>
  <div v-else class="mt-3">
    <div
        v-for="(item, index) in templates"
        v-if="templates.length > 0 && isShow(index)"
        :key="index"
    >
      <div class="title-id">Mẫu số {{ noOfTemplate(index) }}</div>
      <model-form
          :ref="`modelFormRef${index}`"
          :index="index"
          :isAddTemplateBtn="index == indexAddTemplateBtn"
          :pycType="type ? type.toString() : ''"
          @onAddTemplateClick="addNewTemplate"
          @onDelete="onDeleteRow"
      />
      <div v-if="index != indexAddTemplateBtn" class="break-line"></div>
    </div>
  </div>
</template>
<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormDatepicker,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BFormTimepicker,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ModelForm from "../modelForm/modelForm.vue";
import useJwt from "@/auth/jwt/useJwt";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BFormSelect,
    BTabs,
    BTab,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCardText,
    BInputGroup,
    Select2,
    BFormTimepicker,
    FeatherIcon,
    BFormFile,
    ModelForm,
    ValidationProvider,
    ValidationObserver,
  },
  props: {},
  async mounted() {
    await this.getInitDropdownData();
  },
  computed: {
    isValidDate() {
      const start = moment(this.startDate);
      const end = moment(this.endDate);

      return end.isBefore(start);
    },
  },
  watch: {
    templates: {
      immediate: true,
      handler(val, oldVal) {
        this.getIndexAddTemplateBtn();
      },
    },
    posRemoveTemplate: {
      immediate: true,
      handler(val, oldVal) {
        this.getIndexAddTemplateBtn();
      },
    },
  },
  methods: {
    async onContinue() {
      const validate =
          !!this.type &&
          !!this.isUrgent &&
          !!this.campType &&
          !!this.endDate &&
          !!this.startDate &&
          !this.isValidDate;

      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        this.isBlur = true;
        return;
      }
      this.isBlur = false;

      const campTypeName = this.dropListSelectData.find(
          (item) => item.id == +this.campType
      ).text;
      const typeName = this.requestTypeSelectData.find((item) => item.id == +this.type)
          .text;
      const createDate = moment().format("DDMMYYYY");
      const startDate = moment(this.startDate).format("DDMMYYYY");
      const endDate = moment(this.endDate).format("DDMMYYYY");

      const formName = `${campTypeName}_${typeName}_${createDate}_${startDate}_${endDate}`;
      this.isContinue = !this.isContinue;
      this.$emit("onContinue", formName);
    },
    addNewTemplate() {
      this.templates.push("a");
    },
    async getInitDropdownData() {
      const urgentData = await useJwt.get("isUrgent");
      if (urgentData.data && urgentData.data.result) {
        this.urgentSelectData = urgentData.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }

      const requestTypeData = await useJwt.get("requestType");
      if (requestTypeData.data && requestTypeData.data.result) {
        this.requestTypeSelectData = requestTypeData.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }

      const dropListData = await useJwt.get("dropListServices");
      if (dropListData.data && dropListData.data.result) {
        this.dropListSelectData = dropListData.data.result.map((item) => ({
          id: item.id,
          text: item.name,
        }));
      }
    },
    onDeleteRow(index) {
      // this.templates = this.templates.filter((item, idx) => idx != index);
      this.posRemoveTemplate.push(index);
    },
    getNewData() {
      const notifyList = [];

      let isError = false;

      for (const i in this.templates) {
        if (!this.isShow(+i)) {
          continue;
        }
        const ref = this.$refs[`modelFormRef${i}`][0];
        if (ref) {
          const data = ref.getData();
          if (data) {
            notifyList.push(data);
          } else {
            isError = true;
          }
        }
      }

      if (isError) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return null;
      }

      return {
        type: +this.type,
        isUrgent: +this.isUrgent,
        campType: +this.campType,
        endDate: moment(this.endDate).format("yyyy-MM-DD"),
        startDate: moment(this.startDate).format("yyyy-MM-DD"),
        notifyList,
      };
    },
    isShow(index) {
      return this.posRemoveTemplate.filter((item) => item == index).length == 0;
    },
    getIndexAddTemplateBtn() {
      for (let i = this.templates.length - 1; i >= 0; i--) {
        const isAdd = this.posRemoveTemplate.filter((idx) => idx == i).length == 0;
        if (isAdd) {
          this.indexAddTemplateBtn = i;
          return;
        }
      }
    },
    noOfTemplate(index) {
      let num = index;

      for (const i in this.posRemoveTemplate) {
        if (index > this.posRemoveTemplate[i]) {
          num--;
        }
      }

      return num + 1;
    },
  },
  data() {
    return {
      isContinue: false,
      templates: ["1"],
      urgentSelectData: [],
      requestTypeSelectData: [],
      dropListSelectData: [],
      type: null,
      isUrgent: null,
      campType: null,
      endDate: new Date(),
      startDate: new Date(),
      isBlur: false,
      posRemoveTemplate: [],
      indexAddTemplateBtn: 0,
    };
  },
};
</script>
<style lang="scss">
.form-control.error {
  border-color: red;
}

.select2-error .select2-container--default .select2-selection--single {
  border-color: red;
}

.new-model-form-container {
  width: 100%;
  background: white;
}

.upload-img {
  width: 120px;
  height: 120px;
  border: 1px solid gray;
}

.text-align-right {
  text-align: right;
}

.header-new-model {
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 30px;
  color: #ea5455;
  font-weight: bold;
}

.break-line {
  width: 100%;
  height: 1px;
  background: rgb(171, 171, 171);
  margin: 20px 0;
}

.title-id {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 20px;
}
</style>
